import { render } from "./EntityResourceCard.vue?vue&type=template&id=40605e83&ts=true"
import script from "./EntityResourceCard.vue?vue&type=script&lang=ts"
export * from "./EntityResourceCard.vue?vue&type=script&lang=ts"

import "./EntityResourceCard.vue?vue&type=style&index=0&id=40605e83&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__